import mainTheme from "./mainTheme";

export const myTheme = (colorMode: boolean)=> mainTheme(colorMode);
